/* eslint-disable max-classes-per-file */
import { IKartgeometri } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";
import { Subtyp1, Subtyp2, Subtyp3 } from "./kartgeometri.constants";

export class KartgeometriMapping {
    constructor(readonly symbolStyle: string, readonly subtyp1: string, readonly subtyp2?: string, readonly subtyp3?: string) {
    }
}

export class KartgeometriSymbols {
// eslint-disable-next-line sonarjs/public-static-readonly
    static mappings: KartgeometriMapping[] = [
        new KartgeometriMapping("avlagg", Subtyp1.drivningspunkt, Subtyp2.avlagg),
        new KartgeometriMapping("kojplats", Subtyp1.drivningspunkt, Subtyp2.ovrigDrivningspunkt, Subtyp3.ovrigOverfartKojplats),
        new KartgeometriMapping("larmpunkt", Subtyp1.drivningspunkt, Subtyp2.ovrigDrivningspunkt, Subtyp3.ovrigOverfartLarmpunkt),

        new KartgeometriMapping("overfart", Subtyp1.drivningspunkt, Subtyp2.overfart),
        new KartgeometriMapping("kojplats", Subtyp1.drivningspunkt, Subtyp2.ovrigOverfartKojplats),
        new KartgeometriMapping("larmpunkt", Subtyp1.drivningspunkt, Subtyp2.ovrigOverfartLarmpunkt),
        new KartgeometriMapping("overfartDrivning", Subtyp1.drivningspunkt, Subtyp2.ovrigOverfartDrivningstext),
        new KartgeometriMapping("overfartDrivningPoint", Subtyp1.drivningspunkt, Subtyp2.ovrigOverfartDrivningstext),

        new KartgeometriMapping("hansynLinje", Subtyp1.hansynLinje),
        new KartgeometriMapping("hansynYta", Subtyp1.hansynYta),
        new KartgeometriMapping("hansynPunkt", Subtyp1.hansynPunkt),
        new KartgeometriMapping("anvisningYta", Subtyp1.anvisningYta),

        new KartgeometriMapping("drivningslinje", Subtyp1.drivningslinje),
        new KartgeometriMapping("vattendrag", Subtyp1.drivningslinje, Subtyp2.vattendrag),
        new KartgeometriMapping("kraftledning", Subtyp1.drivningslinje, Subtyp2.kraftledning),

        new KartgeometriMapping("bilvag", Subtyp1.vag, Subtyp2.bilvag),
        new KartgeometriMapping("basvag", Subtyp1.vag, Subtyp2.basvag),
        new KartgeometriMapping("vinterbilbasvag", Subtyp1.vag, Subtyp2.vinterbilbasvag),

        new KartgeometriMapping("allmanlinje", Subtyp1.allmanlinje),
        new KartgeometriMapping("allmanlinjeMindreVattendrag", Subtyp1.allmanlinje, Subtyp2.mindreVattendrag),
        new KartgeometriMapping("allmanlinjeBackA", Subtyp1.allmanlinje, Subtyp2.backA),
        new KartgeometriMapping("allmanlinjeJordkabel", Subtyp1.allmanlinje, Subtyp2.jordkabel),
        new KartgeometriMapping("allmanlinjeStup", Subtyp1.allmanlinje, Subtyp2.stup),
        new KartgeometriMapping("allmanlinjeSkyddsdike", Subtyp1.allmanlinje, Subtyp2.skyddsdike),
        new KartgeometriMapping("allmanlinjeStig", Subtyp1.allmanlinje, Subtyp2.stig),
        new KartgeometriMapping("allmanlinjeDike", Subtyp1.allmanlinje, Subtyp2.dike),

        new KartgeometriMapping("allmanpunkt", Subtyp1.allmanpunkt),
        new KartgeometriMapping("allmanpunktBerg", Subtyp1.allmanpunkt, Subtyp2.berg),
        new KartgeometriMapping("allmanpunktBlockmark", Subtyp1.allmanpunkt, Subtyp2.blockmark),
        new KartgeometriMapping("allmanpunktSankmark", Subtyp1.allmanpunkt, Subtyp2.sankmark),
        new KartgeometriMapping("allmanpunktBrantStup", Subtyp1.allmanpunkt, Subtyp2.brantStup)
    ];

    static getSymbolStyles(kartgeometri: IKartgeometri): string[] {
        if (kartgeometri.subtyp1 === Subtyp1.drivningspunkt && kartgeometri.isEditing) {
            return ["editing"];
        }

        if(kartgeometri.subtyp1 === Subtyp1.vag && !kartgeometri.subtyp2 && !kartgeometri.subtyp3) {
            return ["editingLine"];
        }

        const found = this.mappings.filter(m =>
            kartgeometri.subtyp1 === m.subtyp1 &&
            (kartgeometri.subtyp2 === m.subtyp2 || !m.subtyp2) &&
            (kartgeometri.subtyp3 === m.subtyp3 || !m.subtyp3));

        if (found.length === 0) {
            return ["defaultPoint"];
        }

        // eslint-disable-next-line sonarjs/no-misleading-array-reverse
        const bestMatch = found.sort(m => m.subtyp2 ? 1 : -1).sort(m => m.subtyp3 ? 1 : -1)[0];
        return found.filter(m => m.subtyp2 === bestMatch.subtyp2 && m.subtyp3 === bestMatch.subtyp3).map(m => m.symbolStyle);
    }
}
